import React, { useEffect } from "react";
import Wait from "../../../../assets/images/LogoMissing.png";
import { getCafeStatus } from "../../../../api/cafe.api";
import { useSelector } from "react-redux";
import { State } from "../../../../reducer";
import { useNavigate } from "react-router";
import { canBypassClosure } from "../../../../utils/access";

function LandingBar() {
  const user = useSelector((state: State) => state.user);
  const navigate = useNavigate();
  useEffect(() => {
    // put in history
    getCafeStatus().then((result) => {
      if (!result?.isCafeOpen && !result?.isBarOpen && !canBypassClosure(user?.role)) {
        return navigate(
          user?.role === "admin" ? "/close-all-admin" : "/close-all"
        );
      }
    });
    // Mount-only closure check.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div className="px-16 font-nunito gap-8  w-full h-full overflow-y-hidden flex flex-col justify-center items-center bg- text-primary-variant-P200">
      <img src={Wait} className="w-[18rem] mt-24" alt="no-logo" />
      <p className="text-[20px] text-center font-semibold">
        Cocktails are not available for online ordering.
      </p>
      <p>Please order your drink at the bar</p>
      <footer className="text-[12px] gap-4 text-gray-300 flex p-14 w-full justify-center">
        <p>Powered by</p>
        {/* <img src={Beans} className="w-16 h-16" /> */}
        <a
          href="/team-credit"
          className="text-primary-variant-P200 font-medium"
        >
          DEK DUE CREW
        </a>
      </footer>
    </div>
  );
}

export default LandingBar;
